// eslint-disable-next-line import/prefer-default-export
export enum ProspectContactInfoCategory {
  Work = 'work',
  Personal = 'personal',
  Other = 'other',
}
